import React, { useEffect, useRef } from 'react';
import { useThreeD } from './ThreeDViewContext';

/**
 * ThreeDViewContainer — owns the `<div>` that the Cesium viewer attaches to.
 * Mounting attaches the container to the context; unmounting detaches it so
 * the ThreeDViewContext can tear the viewer down cleanly.
 */
export const ThreeDViewContainer: React.FC = () => {
  const { attachContainer, loading, ready, unavailableReason } = useThreeD();
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    attachContainer(divRef.current);
    return () => attachContainer(null);
  }, [attachContainer]);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', background: '#000' }}>
      <div ref={divRef} style={{ width: '100%', height: '100%' }} />

      {(loading || !ready) && (
        <div
          style={{
            position: 'absolute', inset: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#cbd5e1', fontSize: 13, pointerEvents: 'none',
            background: 'rgba(15, 23, 42, 0.6)', textAlign: 'center', padding: 16,
          }}
        >
          {loading && 'Loading 3D engine\u2026'}
          {!loading && !ready && unavailableReason && (
            <div>
              <div style={{ color: '#f59e0b', fontWeight: 600, marginBottom: 4 }}>3D unavailable</div>
              <div style={{ fontSize: 12 }}>{unavailableReason}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
